import * as React from 'react';
import { connect, useDispatch } from 'react-redux';
import { useTypedSelector } from '../../store';
import { ApplicationState } from '../../store/appThunkAction';
import { reorderContent, updateRemoveFile } from '../../store/Meeting/actions';
import { MeetingContent } from '../../store/Meeting/types';
import styles from './index.module.scss';
import LazyItem from '../../components/LazyFileItem';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import CarouselRightArrow from '../../components/Carousel/right';
import CarouselLefttArrow from '../../components/Carousel/left';
import defaultImage from '../../static/media/nocontent.png';
import { openWindow } from '../../utils/dialog';


const initialDnDState: {
    draggedFrom: number,
    draggedTo: number,
    isDragging: boolean,
    originalOrder: MeetingContent[],
    updatedOrder: MeetingContent[]
} = {
    draggedFrom: -1,
    draggedTo: -1,
    isDragging: false,
    originalOrder: [],
    updatedOrder: []
};

const MyPresentation = ({
    isMobile
}: {
    isMobile?:boolean
}) => {
    const dispatch = useDispatch();
    const {
        currentMeeting,
        selectedFilesForRemove,
        theme
    } = useTypedSelector((state: ApplicationState) => state.meeting);
    const {
        files
    } = useTypedSelector((state: ApplicationState) => state.story);

    const [dragAndDrop, setDragAndDrop] = React.useState(initialDnDState);
    const [node, setNode] = React.useState({} as any);
    const [width, setWidth] = React.useState(0);
    const [list, setList] = React.useState(currentMeeting.meetingContents);
    const onDragStart = (event: React.DragEvent<HTMLDivElement>) => {
        const initialPosition = Number(event.currentTarget.dataset.position);
        setDragAndDrop({
            ...dragAndDrop,
            draggedFrom: initialPosition, // set the draggedFrom position
            isDragging: true,
            originalOrder: list // store the current state of "list"
        });
        //only for FF
        event.dataTransfer.setData("text/html", '');
    };
    const onDrop = (_event: React.DragEvent<HTMLDivElement>) => {
        setList(dragAndDrop.updatedOrder);
        setDragAndDrop({
            ...dragAndDrop,
            draggedFrom: -1,
            draggedTo: -1,
            isDragging: false
        });
        onReorderComplete(dragAndDrop.updatedOrder);
    };
    const onDragOver = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        let newList = dragAndDrop.originalOrder;
        const draggedFrom = dragAndDrop.draggedFrom;
        const draggedTo = Number(event.currentTarget.dataset.position);
        const itemDragged = newList[draggedFrom];
        const remainingItems = newList.filter((_item, index) => index !== draggedFrom);
        newList = [
            ...remainingItems.slice(0, draggedTo),
            itemDragged,
            ...remainingItems.slice(draggedTo)
        ];
        if (draggedTo !== dragAndDrop.draggedTo) {
            setDragAndDrop({
                ...dragAndDrop,
                updatedOrder: newList,
                draggedTo: draggedTo
            });
        }
    };

    const GetShareStatus = (fileId: number) => {
        if (fileId && currentMeeting && currentMeeting.meetingContents && currentMeeting.meetingContents.length > 0) {
            const item = currentMeeting.meetingContents.filter(c => c.fileId === fileId).map((item) => {
                return {
                    ...files[item.fileId]
                };
            })[0];
            //  const cacheItem = currentFiles.find(c=>c.id === item.id);
            if (item && item != null && item != undefined)
                return item.shareStatus;
            else
                return '';
        };
        //hideDialog();
    };

    const onReorderComplete = (items: MeetingContent[]) => {
        const data = items.map((item, index) => {
            return {
                id: item.id,
                order: index
            }
        });
        dispatch(reorderContent(currentMeeting.id, [...data]));
    };
    React.useEffect(() => {
        setList(currentMeeting.meetingContents);
    }, [currentMeeting.meetingContents]);
    const onItemSelected = (fileId: number) => {
        if (!isMobile) {
            const url = `https://app.bigtincan.com/file/p/${fileId}`;
            openWindow(url);
        }
    };

    const onCheckedChange = (fileId: number, checked: boolean) => {
        dispatch(updateRemoveFile(fileId, checked ?  "add" : 'remove'));
        /*
        if (!checked) {
            const newItems = selectedItems.filter(c => c !== fileId);
            updateSelectedItems(newItems);
            onSelectedItemsChanges(newItems);
        } else {
            const newItems = [...selectedItems, fileId];
            updateSelectedItems(newItems);
            onSelectedItemsChanges(newItems);
        }*/
    };
    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 10 },
            items: width / (192 + 26)
        },
    };
    React.useEffect(() => {
        function handleResize() {
            setWidth(node.offsetWidth)
        }
    
        window.addEventListener('resize', handleResize)
    }, [node]);
    React.useEffect(() => {
       setWidth(width);
    }, [list]);
    return (
        <div className={[styles.root, styles["ms-teams-theme-" + theme]].join(' ')}>
            <h1>My Presentation</h1>
            {list && list.length > 0 && <div ref={node => {
                node && setNode(node);
                node && setWidth(node.offsetWidth);
            }} style={{ overflow: 'auto', width: '100%', height: '100%' }}>
                <Carousel slidesToSlide={5} responsive={responsive} customLeftArrow={<CarouselLefttArrow />} customRightArrow={<CarouselRightArrow />} >
                    {list.length > 0 && list.map((row, index) => {
                        return (
                            <LazyItem
                                disableClick={isMobile}
                                onCheckedChange={onCheckedChange}
                                checked={!!selectedFilesForRemove.find(c => c === row.fileId)}
                                hover={index === dragAndDrop.draggedTo}
                                selected={index === dragAndDrop.draggedFrom}
                                data-position={index} onDragOver={onDragOver}
                                onDragStart={onDragStart} onDrop={onDrop}
                                onItemClick={onItemSelected}
                                actionIcon="ChromeClose"
                                key={row.fileId}
                                shareStatus={GetShareStatus(row.fileId)}
                                fileId={row.fileId} />);
                    })}
                </Carousel>
            </div>}
            {list && list.length === 0 && <div className={styles.noContent}>
                <figure>
                    <img src={defaultImage} />
                    <figcaption>Add Files!</figcaption>
                    <p>Prepare before your meeting.</p>
                </figure>
            </div>}
        </div>
    )
};

export default connect()(MyPresentation);
